import { render, staticRenderFns } from "./Architecture.vue?vue&type=template&id=08dfe694&"
import script from "./Architecture.vue?vue&type=script&lang=ts&"
export * from "./Architecture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports